import { PlatformControllerFlowAPI } from '@wix/yoshi-flow-editor';

import { getMyRewardsPageUrl } from './getMyRewardsPageUrl';

export async function isMyRewardsPageInstalled(flowAPI: PlatformControllerFlowAPI): Promise<boolean> {
  const myRewardsPageUrl = await getMyRewardsPageUrl(flowAPI);
  return !!myRewardsPageUrl;
}
